<template>
    <div>
        <a-card :title="$t('text.userInfo')" :loading="isLoadingInfo" class="mb-20">
            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                <a-form-item :label="$t('labelText.user_name')">{{ userInfo?.name }}</a-form-item>

                <a-form-item :label="$t('labelText.user_email')">{{ userInfo?.email || $t('text.notUpdated') }}
                </a-form-item>

                <a-form-item :label="$t('labelText.user_tel')">{{ userInfo?.tel || $t('text.notUpdated') }}
                </a-form-item>

                <a-form-item :label="$t('labelText.user_coin')">{{ number_format(userInfo?.coin) }}</a-form-item>
                <a-form-item :label="$t('labelText.user_promotion_coin')">{{ number_format(userInfo?.promotion_coin) }}
                </a-form-item>
                <a-form-item :label="$t('labelText.user_point')">{{ number_format(userInfo?.point) }}</a-form-item>
                <a-form-item :label="$t('labelText.created_at')">{{ userInfo?.created_at }}</a-form-item>
                <a-form-item :label="$t('labelText.updated_at')">{{ userInfo?.updated_at }}</a-form-item>
            </a-form>
        </a-card>

        <a-card title="Đổi thông tin bảo mật tài khoản" :loading="isLoadingInfo" class="mb-20">
            <a-collapse>
                <a-collapse-panel :header="$t('text.updateUserInfo')"
                    v-if="!(userInfo && (userInfo?.email !== null) && (userInfo?.email?.length > 0)) || !(userInfo && (userInfo?.tel !== null) && (userInfo?.tel?.length > 0))">
                    <a-form ref="formInfo" :model="formModelInfo" @finish="onFinishInfo" :rules="formRuleInfo"
                        :scrollToFirstError="true" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                        <a-form-item :label="$t('labelText.user_email')" name="email">
                            <a-input v-model:value="formModelInfo.email"
                                :disabled="userInfo && (userInfo?.email !== null) && (userInfo?.email?.length > 0)"
                                placeholder="some.email@gmail.com" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_tel')" name="tel">
                            <a-input v-model:value="formModelInfo.tel"
                                :disabled="userInfo && (userInfo?.tel !== null) && (userInfo?.tel?.length > 0)"
                                placeholder="0312345678" />
                        </a-form-item>

                        <a-form-item :wrapper-col="{ lg: {span: 20, offset: 4}, md: {span:24, offset: 0}}">
                            <a-button type="primary" html-type="submit" block :loading="isSavingInfo">{{ $t('text.save')
                            }}
                            </a-button>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
                <a-collapse-panel :header="$t('text.updateUserPassword')">
                    <a-form ref="formPw" :model="formModelPw" @finish="onFinishPw" :rules="formRulePw"
                        :scrollToFirstError="true" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                        <a-form-item :label="$t('labelText.cur_password')" name="cur_password">
                            <a-input-password v-model:value="formModelPw.cur_password" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.new_password')" name="new_password">
                            <a-input-password v-model:value="formModelPw.new_password" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.password_confirm')" name="password_confirm">
                            <a-input-password v-model:value="formModelPw.password_confirm" />
                        </a-form-item>

                        <a-form-item :wrapper-col="{ lg: {span: 20, offset: 4}, md: {span:24, offset: 0}}">
                            <a-button type="primary" html-type="submit" block :loading="isSavingPw">{{ $t('text.save') }}</a-button>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
                <a-collapse-panel header="Đổi mật khẩu cấp 2"
                    :disabled="!userInfo?.tel || !userInfo?.email || (!userInfo?.has_qa && userInfo?.has_pw2)">
                    <a-form ref="formPw2" name="formPw2" :model="formModelPw2" @finish="onFinishPw2"
                        :rules="formRulePw2" :scrollToFirstError="true" :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 20 }"
                    >
                        <a-form-item :label="$t('labelText.user_tel')" name="tel" :hidden="!userInfo?.has_pw2"
                            :required="userInfo?.has_pw2">
                            <a-input v-model:value="formModelPw2.tel" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_question') + ' hiện tại'" name="question"
                            :hidden="!userInfo?.has_pw2" :required="userInfo?.has_pw2">
                            <a-select :options="optionsSecurityQuestion" v-model:value="formModelPw2.question" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_answer') + ' hiện tại'" name="answer"
                            :hidden="!userInfo?.has_pw2" :required="userInfo?.has_pw2">
                            <a-input v-model:value="formModelPw2.answer" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.new_password')" name="password2">
                            <a-input-password v-model:value="formModelPw2.password2" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.password_confirm')" name="password2_confirm">
                            <a-input-password v-model:value="formModelPw2.password2_confirm" />
                        </a-form-item>

                        <a-form-item :wrapper-col="{ lg: {span: 20, offset: 4}, md: {span:24, offset: 0}}">
                            <a-button type="primary" html-type="submit" block :loading="isSavingPw2">{{ $t('text.save')
                            }}
                            </a-button>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
                <a-collapse-panel header="Đổi câu hỏi bảo mật"
                    :disabled="!userInfo?.tel || !userInfo?.email || (!userInfo?.has_pw2 && userInfo?.has_qa)">
                    <a-form ref="formChangeSecureQA" name="formChangeSecureQA" :model="formModelChangeSecureQA"
                        @finish="onFinishChangeSecureQA" :rules="formRuleChangeSecureQA" :scrollToFirstError="true"
                        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                        <a-form-item :label="$t('labelText.user_tel')" name="tel" :hidden="!userInfo?.has_qa"
                            :required="userInfo?.has_qa">
                            <a-input v-model:value="formModelChangeSecureQA.tel" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.password2')" name="password2" :hidden="!userInfo?.has_qa"
                            :required="userInfo?.has_qa">
                            <a-input-password v-model:value="formModelChangeSecureQA.password2" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_question') + ' mới'" name="question">
                            <a-select :options="optionsSecurityQuestion"
                                v-model:value="formModelChangeSecureQA.question" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_answer') + ' mới'" name="answer">
                            <a-input v-model:value="formModelChangeSecureQA.answer" />
                        </a-form-item>

                        <a-form-item :wrapper-col="{ lg: {span: 20, offset: 4}, md: {span:24, offset: 0}}">
                            <a-button type="primary" html-type="submit" block :loading="isSavingChangeSecureQA">{{
                            $t('text.save')
                            }}
                            </a-button>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
                <a-collapse-panel header="Đổi email và số điện thoại"
                    :disabled="!userInfo?.has_pw2 || !userInfo?.has_qa || !userInfo?.email?.length || !userInfo?.tel?.length">
                    <a-form ref="formChangeAllSecureInfo" name="formChangeAllSecureInfo"
                        :model="formModelChangeAllSecureInfo" @finish="onFinishChangeAllSecureInfo"
                        :rules="formRuleChangeAllSecureInfo" :scrollToFirstError="true" :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 20 }">
                        <a-form-item :label="$t('labelText.password2') + ' hiện tại'" name="cur_password2">
                            <a-input-password v-model:value="formModelChangeAllSecureInfo.cur_password2" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_question') + ' hiện tại'" name="cur_question">
                            <a-select :options="optionsSecurityQuestion"
                                v-model:value="formModelChangeAllSecureInfo.cur_question" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_answer') + ' hiện tại'" name="cur_answer">
                            <a-input v-model:value="formModelChangeAllSecureInfo.cur_answer" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_email') + ' hiện tại'" name="cur_email">
                            <a-input v-model:value="formModelChangeAllSecureInfo.cur_email" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_tel') + ' hiện tại'" name="cur_tel">
                            <a-input v-model:value="formModelChangeAllSecureInfo.cur_tel" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_email') + ' mới'" name="email">
                            <a-input v-model:value="formModelChangeAllSecureInfo.email" />
                        </a-form-item>

                        <a-form-item :label="$t('labelText.user_tel') + ' mới'" name="tel">
                            <a-input v-model:value="formModelChangeAllSecureInfo.tel" />
                        </a-form-item>

                        <a-form-item :wrapper-col="{ lg: {span: 20, offset: 4}, md: {span:24, offset: 0}}">
                            <a-button type="primary" html-type="submit" block :loading="isSavingChangeAllSecureInfo">{{
                            $t('text.save') }}</a-button>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
            </a-collapse>
        </a-card>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import { Button, Card, Collapse, Form, Input, message, Select, } from 'ant-design-vue';
import { RuleObject } from 'ant-design-vue/lib/form';

import { StoreType as UserStoreType, UserInfo } from '@/store/modules/user';
import ApiRequest from '@/utils/ApiRequest';
import { number_format } from '@/utils/helpers';
import { optionsSecurityQuestion } from '@/store/modules/user';

interface FormModelChangeAllSecureInfo {
    cur_question: string;
    cur_answer: string;
    cur_password2: string;
    cur_email: string;
    cur_tel: string;
    tel: string;
    email: string;
}

interface FormModelInfo {
    tel: string;
    email: string;
}

interface FormModelPw {
    cur_password: string;
    new_password: string;
    password_confirm: string;
}

interface FormModelPw2 {
    tel: string;
    question: string,
    answer: string,
    // cur_password: string;
    password2: string;
    password2_confirm: string;
}

interface FormModelChangeSecureQA {
    password2: string;
    tel: string;
    // cur_question: string,
    // cur_answer: string,
    question: string,
    answer: string,
}

export default defineComponent({
    components: {
        ACard: Card,
        AButton: Button,
        AForm: Form,
        AFormItem: Form.Item,
        AInput: Input,
        AInputPassword: Input.Password,
        ACollapse: Collapse,
        ACollapsePanel: Collapse.Panel,
        ASelect: Select,
    },

    setup() {
        const { t } = useI18n();
        const store = useStore();

        const userInfo = ref<UserInfo>();

        const fetchData = () => {
            isLoadingInfo.value = true;
            store.dispatch(UserStoreType.FETCH_USER)
                .then(() => {
                    //
                    isLoadingInfo.value = false;
                })
                .finally(() => {
                    //
                });
        };

        const isLoadingInfo = ref(true);
        const formInfo = ref<typeof Form>();
        const isSavingInfo = ref(false);
        const formModelInfo = reactive<FormModelInfo>({
            tel: '',
            email: '',
        });
        const formExtraErrorInfo: Record<keyof FormModelInfo, string> = {
            tel: '',
            email: '',
        };
        const formRuleInfo = reactive<Record<keyof FormModelInfo, RuleObject[]>>({
            tel: [
                {
                    required: true,
                    max: 15,
                    trigger: 'change',
                },
                {
                    pattern: /^[0-9]+$/,
                    trigger: 'change',
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorInfo[_rule.field as keyof FormModelInfo] || undefined),
                },
            ],
            email: [
                {
                    required: true,
                    type: 'email',
                    trigger: 'change',
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorInfo[_rule.field as keyof FormModelInfo] || undefined),
                },
            ],
        });
        const onFinishInfo = (values: FormModelInfo) => {
            isSavingInfo.value = true;

            ApiRequest.post(`/users/${userInfo.value?.id}`, values).then(() => {
                formPw2.value?.resetFields();
                message.success(t('message.updateSuccess'));

                fetchData();
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorInfo, formInfo.value);
                })
                .finally(() => {
                    isSavingInfo.value = false;
                });
        };

        const formPw = ref<typeof Form>();
        const isSavingPw = ref(false);
        const formModelPw = reactive<FormModelPw>({
            cur_password: '',
            new_password: '',
            password_confirm: '',
        });
        const formExtraErrorPw: Record<keyof FormModelPw, string> = {
            cur_password: '',
            new_password: '',
            password_confirm: '',
        };
        const formRulePw = reactive<Record<keyof FormModelPw, RuleObject[]>>({
            cur_password: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw[_rule.field as keyof FormModelPw] || undefined),
                },
            ],
            new_password: [
                {
                    required: true,
                    min: 8,
                    trigger: ['blur', 'change'],
                },
                {

                    validator: (_rule, value, callback) => callback((value && (value === formModelPw.cur_password)) ? t('message.passwordSame') : undefined),
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw[_rule.field as keyof FormModelPw] || undefined),
                },
            ],
            password_confirm: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {

                    validator: (_rule, value, callback) => callback((value && (value !== formModelPw.new_password)) ? t('message.passwordNotMatch') : undefined),
                    trigger: ['blur', 'change'],
                },
            ],
        });
        const onFinishPw = (values: FormModelPw) => {
            isSavingPw.value = true;

            ApiRequest.post(`/users/${userInfo.value?.id}/password`, values).then(() => {
                formPw.value?.resetFields();
                message.success(t('message.updateSuccess'));
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorPw, formPw.value);
                })
                .finally(() => {
                    isSavingPw.value = false;
                });
        };

        const formChangeSecureQA = ref<typeof Form>();
        const isSavingChangeSecureQA = ref(false);
        const formModelChangeSecureQA = reactive<FormModelChangeSecureQA>({
            password2: '',
            tel: '',
            question: '',
            answer: '',
        });
        const formExtraErrorChangeSecureQA: Record<keyof FormModelChangeSecureQA, string> = {
            password2: '',
            tel: '',
            question: '',
            answer: '',
        };
        const formRuleChangeSecureQA = reactive<Record<keyof FormModelChangeSecureQA, RuleObject[]>>({
            password2: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeSecureQA[_rule.field as keyof FormModelChangeSecureQA] || undefined),
                },
            ],
            tel: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeSecureQA[_rule.field as keyof FormModelChangeSecureQA] || undefined),
                },
            ],
            question: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeSecureQA[_rule.field as keyof FormModelChangeSecureQA] || undefined),
                },
            ],
            answer: [
                {
                    required: true,
                    min: 4,
                    trigger: ['blur', 'change'],
                },
                {

                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeSecureQA[_rule.field as keyof FormModelChangeSecureQA] || undefined),
                },
            ],
        });
        const onFinishChangeSecureQA = (values: FormModelChangeSecureQA) => {
            isSavingChangeSecureQA.value = true;

            ApiRequest.post(`/users/${userInfo.value?.id}/qa`, values).then(() => {
                formChangeSecureQA.value?.resetFields();
                message.success(t('message.updateSuccess'));

                fetchData();
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorChangeSecureQA, formChangeSecureQA.value);
                })
                .finally(() => {
                    isSavingChangeSecureQA.value = false;
                });
        };

        const formChangeAllSecureInfo = ref<typeof Form>();
        const isSavingChangeAllSecureInfo = ref(false);
        const formModelChangeAllSecureInfo = reactive<FormModelChangeAllSecureInfo>({
            cur_question: '',
            cur_answer: '',
            cur_password2: '',
            cur_tel: '',
            cur_email: '',
            tel: '',
            email: '',
        });
        const formExtraErrorChangeAllSecureInfo: Record<keyof FormModelChangeAllSecureInfo, string> = {
            cur_question: '',
            cur_answer: '',
            cur_password2: '',
            cur_tel: '',
            cur_email: '',
            tel: '',
            email: '',
        };
        const formRuleChangeAllSecureInfo = reactive<Record<keyof FormModelChangeAllSecureInfo, RuleObject[]>>({
            cur_question: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            cur_answer: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            cur_password2: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            cur_email: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            cur_tel: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            tel: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {
                    pattern: /^[0-9]+$/,
                    trigger: 'change',
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
            email: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {

                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorChangeAllSecureInfo[_rule.field as keyof FormModelChangeAllSecureInfo] || undefined),
                },
            ],
        });
        const onFinishChangeAllSecureInfo = (values: FormModelChangeAllSecureInfo) => {
            isSavingChangeAllSecureInfo.value = true;

            ApiRequest.post(`/users/${userInfo.value?.id}/full-info`, values).then(() => {
                formChangeAllSecureInfo.value?.resetFields();

                message.success(t('message.updateSuccess'));

                fetchData();
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorChangeAllSecureInfo, formChangeAllSecureInfo.value);
                })
                .finally(() => {
                    isSavingChangeAllSecureInfo.value = false;
                });
        };

        const formPw2 = ref<typeof Form>();
        const isSavingPw2 = ref(false);
        const formModelPw2 = reactive<FormModelPw2>({
            question: '',
            answer: '',
            tel: '',
            password2: '',
            password2_confirm: '',
        });
        const formExtraErrorPw2: Record<keyof FormModelPw2, string> = {
            question: '',
            answer: '',
            tel: '',
            password2: '',
            password2_confirm: '',
        };
        const formRulePw2 = reactive<Record<keyof FormModelPw2, RuleObject[]>>({
            question: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw2[_rule.field as keyof FormModelPw2] || undefined),
                },
            ],
            answer: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw2[_rule.field as keyof FormModelPw2] || undefined),
                },
            ],
            tel: [
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw2[_rule.field as keyof FormModelPw2] || undefined),
                },
            ],
            password2: [
                {
                    required: true,
                    min: 8,
                    trigger: ['blur', 'change'],
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraErrorPw2[_rule.field as keyof FormModelPw2] || undefined),
                },
            ],
            password2_confirm: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                },
                {

                    validator: (_rule, value, callback) => callback((value && (value !== formModelPw2.password2)) ? t('message.passwordNotMatch') : undefined),
                    trigger: ['blur', 'change'],
                },
            ],
        });
        const onFinishPw2 = (values: FormModelPw2) => {
            isSavingPw2.value = true;

            ApiRequest.post(`/users/${userInfo.value?.id}/password2`, values).then(() => {
                formPw2.value?.resetFields();
                message.success(t('message.updateSuccess'));

                fetchData();
            })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraErrorPw2, formPw2.value);
                })
                .finally(() => {
                    isSavingPw2.value = false;
                });
        };

        watch(() => store.getters.user, (newValue) => {
            userInfo.value = newValue;

            formModelInfo.email = newValue.email;
            formModelInfo.tel = newValue.tel;
        });

        onMounted(() => {
            fetchData();
        });

        return {
            isLoadingInfo,
            formInfo,
            isSavingInfo,
            formModelInfo,
            formRuleInfo,
            onFinishInfo,

            formPw,
            isSavingPw,
            formModelPw,
            formRulePw,
            onFinishPw,

            formChangeSecureQA,
            isSavingChangeSecureQA,
            formModelChangeSecureQA,
            formRuleChangeSecureQA,
            onFinishChangeSecureQA,
            optionsSecurityQuestion,

            formChangeAllSecureInfo,
            isSavingChangeAllSecureInfo,
            formModelChangeAllSecureInfo,
            formRuleChangeAllSecureInfo,
            onFinishChangeAllSecureInfo,

            formPw2,
            isSavingPw2,
            formModelPw2,
            formRulePw2,
            onFinishPw2,

            userInfo,

            number_format,
        };
    },
});
</script>
